"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isoDateStringToDbDate = exports.isoDateStringToIsoDateOnlyString = void 0;
const luxon_1 = require("luxon");
const isoDateStringToIsoDateOnlyString = (dateTimeString) => {
    const dt = luxon_1.DateTime.fromISO(dateTimeString);
    if (!dt.isValid) {
        throw new Error("Invalid datetime");
    }
    return dt.toISO().substring(0, 10);
};
exports.isoDateStringToIsoDateOnlyString = isoDateStringToIsoDateOnlyString;
const isoDateStringToDbDate = (dateTimeString) => exports.isoDateStringToIsoDateOnlyString(dateTimeString);
exports.isoDateStringToDbDate = isoDateStringToDbDate;
//# sourceMappingURL=date_utils.js.map